<template>
  <div class="search-box" v-if="!isSearchDataEmpty">
    <slot name="before"></slot>
    <div class="search-box-con">
      <div class="search-box-con__left">
        <span class="search-box-con__left-text" v-if="false"> {{ title }}</span>
        <div
          class="search-box-form"
          v-for="(item, idx) in searchDataIsVisible"
          :key="idx"
        >
          <div class="search-box-form__select" v-if="item.type === 'select'">
            <span class="search-box-form__text">
              {{ item.title }}
            </span>
            <el-select
              size="small"
              v-model="query[item.model]"
              :style="{ width: item.width }"
              :clearable="item.clearable"
              :filterable="item.filterable"
              @change="emitSearchChange"
            >
              <el-option
                v-for="(i,d) in item.enumType
                  ? $enums[item.enumType].allList()
                  : item.option"
                :label="i.label"
                :value="i.value"
                :key="(d + i.value)"
              >
              </el-option>
            </el-select>
          </div>
          <div
            class="search-box-form__cascader"
            v-if="item.type === 'cascader'"
          >
            <span class="search-box-form__text">
              {{ item.title }}
            </span>
            <el-cascader
              size="small"
              v-model="item.model"
              :style="{ width: item.width }"
              :options="item.option"
              :placeholder="item.placeholder"
              :filterable="item.filterable"
              :clearable="item.clearable"
              change-on-select
              @change="value => cascaderChange(value, item)"
            >
            </el-cascader>
          </div>

          <div
            class="search-box-form__date-section"
            v-if="item.type === 'dateRange'"
          >
            <span class="search-box-form__text">
              {{ item.title }}
            </span>
            <el-date-picker
              size="small"
              class="search-box-form__date search-box-form__input"
              v-model="date"
              type="daterange"
              align="right"
              unlink-panels
              @change="value => dateChange(value, item)"
              start-placeholder="From"
              end-placeholder="To"
              format="dd-MM-yyyy"
            >
              <!-- :picker-options="pickerOptions" -->
            </el-date-picker>
          </div>
          <div
            class="search-box-form__date-section"
            v-if="item.type === 'dateRanges'"
          >
            <span class="search-box-form__text">
              {{ item.title }}
            </span>
            <el-date-picker
              size="small"
              class="search-box-form__date search-box-form__input"
              v-model="date"
              type="daterange"
              align="right"
              unlink-panels
              @change="value => dateChange(value, item)"
              start-placeholder="From"
              end-placeholder="To"
              format="dd-MM-yyyy"
              :picker-options="pickerycOptions"
            >
              <!-- :picker-options="pickerOptions" -->
            </el-date-picker>
          </div>

          <div class="search-box-form__date" v-if="item.type === 'date'">
            <span class="search-box-form__text">
              {{ item.title }}
            </span>
            <el-date-picker
              size="small"
              class="search-box-form__date"
              el-date-picker.date(
              v-model="item.initialDate"
              :format="item.dateType === 'month' ? 'yyyy年MM月' : 'yyyy-MM-dd'"
              :type="item.dateType"
              @change="value => dateSingeChange(value, item)"
              placeholder="选择时间"
            >
            </el-date-picker>
          </div>

          <div class="search-box-form__input" v-if="item.type === 'input'">
            <span class="search-box-form__text">
              {{ item.title || 'keyword' }}
            </span>
            <el-input
              size="small"
              :clearable="item.clearable"
              v-model="query[item.model]"
              :placeholder="item.placeholder || 'Search'"
              @keyup.enter.native="emitSearchChange"
              @clear="emitSearchChange"
            >
              <el-button
                slot="append"
                @click="emitSearchChange"
                icon="el-icon-search search-box-form__input--btn"
              >
              </el-button>
            </el-input>
          </div>
        </div>
      </div>
      <div class="search-box-con__right">
        <slot name="action"></slot>
      </div>
    </div>
    <slot name="after"></slot>
  </div>
</template>

<script>
import _ from 'lodash'
import dayjs from 'dayjs'

export default {
  props: {
    searchData: {
      type: Array,
      default() {
        return []
      }
    },
    title: {
      type: String,
      default: ''
    },
    query: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  computed: {
    searchDataIsVisible() {
      return this.searchData.filter(t => !t.hide)
    },
    isSearchDataEmpty() {
      return _.isEmpty(this.searchData)
    }
  },
  data() {
    return {
      // 多选日期
      date: ['', ''],
      limitDay: 14 * 24 * 3600 * 1000,
      pickerycOptions: {
        onPick: ({ minDate }) => {
          if (minDate && this.pickerMinDate) {
            this.pickerMinDate = null;
          } else if (minDate) {
            this.pickerMinDate = minDate.getTime();
          }
        },
        disabledDate: (time) => {
          if (this.pickerMinDate) {
            return (
              time.getTime() > this.pickerMinDate + this.limitDay ||
              time.getTime() < this.pickerMinDate - this.limitDay
            );
          }
          return false;
        },
      },
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(
                new Date(new Date().setMonth(new Date().getMonth() - 1))
              )
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(
                new Date(new Date().setMonth(new Date().getMonth() - 3))
              )
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近六个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(
                new Date(new Date().setMonth(new Date().getMonth() - 6))
              )
              picker.$emit('pick', [start, end])
            }
          }
        ]
      }
    }
  },
  methods: {
    emitSearchChange() {
      this.$emit('search-change')
    },
    onSelectClear(model) {
      this.query[model] = null
      // this.emitSearchChange()
    },
    // cascader 值改变的时候
    cascaderChange(val, item) {
      if (val.length) {
        // this.query[item.modelName[0]] = val[0]
        // this.query[item.modelName[1]] = val[1]
        if (item.lastValue) {
          this.query[item.modelName[item.modelName.length - 1]] =
            val[val.length - 1]
        } else {
          item.modelName.map((t, idx) => {
            this.query[t] = val[idx]
          })
        }
      } else {
        // this.query[item.modelName[0]] = null
        // this.query[item.modelName[1]] = null
        item.modelName.map(t => {
          this.query[t] = null
        })
      }
      this.emitSearchChange()
    },
    // 日期选择控件切换的回调
    dateChange(val, item) {
      if (val === null) {
        this.$set(this.query, item.modelName[0], null)
        this.$set(this.query, item.modelName[1], null)
      } else {
        this.$set(
          this.query,
          item.modelName[0],
          dayjs(val[0]).format('YYYY-MM-DD 00:00:00')
        )
        this.$set(
          this.query,
          item.modelName[1],
          dayjs(val[1]).format('YYYY-MM-DD 23:59:59')
        )
      }
      this.emitSearchChange()
    },
    // 日期单选控件切换的回调
    dateSingeChange(val, item) {
      this.query[item.model] = dayjs(val).format('YYYY-MM-DD HH:mm:ss')
      this.emitSearchChange()
    }
  },
  mounted() {
    for (let i = 0; i < this.searchData.length; i++) {
      if (this.searchData[i].type === 'dateRange' && this.searchData[i].dateFrom) {
        this.date = [this.searchData[i].dateFrom, this.searchData[i].dateTo]
      }
      if (this.searchData[i].type === 'dateRanges' && this.searchData[i].dateFrom) {
        this.date = [this.searchData[i].dateFrom, this.searchData[i].dateTo]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.search-box {
  margin-bottom: 10px;
  &-con {
    @include hor-between-center;

    &__left {
      &-text {
        margin-right: 10px;
        font-size: 24px;
        color: #444;
        font-weight: 500;
      }
    }

    &__right {
      margin-right: 10px;
    }
  }

  &-form {
    display: inline-block;
    margin-right: 10px;

    &__text {
      display: block;
      margin-left: 5px;
      margin-bottom: 8px;
      font-size: $font-size-normal;
      font-weight: bold;
      color: #666;
      text-transform: uppercase;
    }

    &__input {
      width: 200px;
      >>> .el-input-group__append {
        padding: 0 10px !important;
      }
    }

    &__date {
      width: 240px;
    }

    >>> .el-select {
      width: 200px;
      display: block;
    }

    >>> .el-cascader {
      width: 200px;
      display: block;
    }
  }
}
</style>
